/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4-beta.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WorkorderSurveyCompleteCommandFromJSON(json) {
    return WorkorderSurveyCompleteCommandFromJSONTyped(json, false);
}
export function WorkorderSurveyCompleteCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'surveyText': !exists(json, 'surveyText') ? undefined : json['surveyText'],
        'surveyRating': !exists(json, 'surveyRating') ? undefined : json['surveyRating'],
    };
}
export function WorkorderSurveyCompleteCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'surveyText': value.surveyText,
        'surveyRating': value.surveyRating,
    };
}
